import React, { useState } from 'react';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '../../lib/supabase';
import PrivacyPolicy from '../legal/PrivacyPolicy';
import TermsOfUse from '../legal/TermsOfUse';

export default function AuthModal({ isOpen, onClose, view = "sign_in" }) {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  if (!isOpen) return null;

  return (
    <>
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">
            {view === 'sign_in' ? 'Sign In' : 'Join Us'}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
        <Auth
          supabaseClient={supabase}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: 'var(--cling-purple)',
                  brandAccent: 'var(--cling-pink)',
                }
              }
            },
            className: {
              container: 'font-space-grotesk',
              button: 'font-space-grotesk',
              input: 'font-space-grotesk'
            }
          }}
          theme="light"
          providers={[]}
          view={view}
          onAuthSuccess={(session) => {
            console.log('🎉 Auth Success in Modal:', session?.user?.email);
          }}
        />
          <p className="text-xs text-center text-gray-600 mt-4 font-space-grotesk">
            By logging in or signing up, you agree to our{' '}
            <button
              className="underline text-indigo-500 hover:text-indigo-700"
              type="button"
              onClick={() => setShowPrivacy(true)}
            >
              Privacy Policy
            </button>{' '}
            and{' '}
            <button
              className="underline text-indigo-500 hover:text-indigo-700"
              type="button"
              onClick={() => setShowTerms(true)}
            >
              Terms of Use
            </button>.
          </p>
    </div>
      </div>
      <PrivacyPolicy isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} />
      <TermsOfUse isOpen={showTerms} onClose={() => setShowTerms(false)} />
    </>
  );
}